// @owners { team: patients }
import { COLORS, SPACING } from '@alto/design-library-tokens';
import {
  Card,
  Column,
  ContentLoader,
  FlatCard,
  LgPadding,
  LoadingEmptyState,
  MdSpacing,
  SecondaryPage,
  SmSpacing,
} from '@alto/design-system';
import React from 'react';

export const OrderDetailsLoading = () => {
  return (
    <SecondaryPage
      dismissIcon="chevronleft"
      headerBackgroundColor={COLORS.BACKGROUND_COLORS.TERTIARY_LIGHTEST}
      NavBarCenterContent="Order details"
    >
      <Card
        title="Loading order details..."
        overflow="visible"
      >
        <LgPadding topPadding={SPACING.STATIC.NONE}>
          <SmSpacing />
          <LoadingEmptyState />
        </LgPadding>
      </Card>
      <MdSpacing />
      <Card>
        <LgPadding>
          <Column center>
            <ContentLoader accessibilityLabel="loading medication details" />
          </Column>
        </LgPadding>
      </Card>
      <MdSpacing />
      <Card>
        <FlatCard>
          <LgPadding>
            <Column center>
              <ContentLoader accessibilityLabel="loading pricing details" />
            </Column>
          </LgPadding>
        </FlatCard>
      </Card>
    </SecondaryPage>
  );
};
